import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSetting } from '../../../helpers/Settings';

const UploadPageDetailsTabs = ({ activeTab, handleSwitchTab }) => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs">
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'collected-details' })}
          onClick={() => { handleSwitchTab('collected-details'); }}
        >
          {intl.formatMessage({ defaultMessage: 'Collected details' })}
        </NavLink>
      </NavItem>
      {(
        getSetting('upload_pages_require_accept_document') === '1'
      ) && (
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === 'tos' })}
            onClick={() => { handleSwitchTab('tos'); }}
          >
            {intl.formatMessage({ defaultMessage: 'Accepted Terms of Service' })}
          </NavLink>
        </NavItem>
      )}
    </Nav>
  );
};

UploadPageDetailsTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

export default UploadPageDetailsTabs;
